import { render, staticRenderFns } from "./ArticleSelected.vue?vue&type=template&id=cc47960e&"
import script from "./ArticleSelected.vue?vue&type=script&lang=js&"
export * from "./ArticleSelected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports